import React from 'react';
import { StarIcon, TrophyIcon } from 'lucide-react';
import { MatchedSchool } from '../services/matchingApi';
interface MatchedSchoolCardProps {
  school: MatchedSchool;
  index: number;
}
export function MatchedSchoolCard({
  school,
  index
}: MatchedSchoolCardProps) {
  const name = (school.mBrandName || school.brandName || school.schoolname || '') as string;
  const headline = (school.headContent || school.headline || '') as string;
  const bodyHtml = (school.bodyContent || '') as string;
  const logo = (school.imageURL || school.logoUrl || school.logourl || '') as string;
  const clickUrl = (school.clickURL || school.clickUrl || school.url || '') as string;
  const badge = (school.ribbonText || school.badge || '') as string;
  const position = (school.mPosition || index + 1) as number;
  const isFirst = index === 0;
  const schoolInitials = (name || 'SC').split(' ').filter(w => w.length > 0).map(w => w[0]).join('').substring(0, 3).toUpperCase();
  return <div className="relative" data-id="element-255">
      {/* #1 Recommended School Banner */}
      {isFirst && <div className="bg-[#1e293b] rounded-t-xl px-4 py-2.5 flex items-center justify-center gap-2" data-id="element-256">
          <TrophyIcon className="w-4 h-4 text-yellow-400" data-id="element-257" />
          <span className="text-white text-sm font-bold tracking-wide" data-id="element-258">
            #1 Recommended School
          </span>
        </div>}

      <div className={`bg-white border border-gray-200 shadow-sm overflow-hidden ${isFirst ? 'rounded-b-xl border-t-0 ring-2 ring-[#1e293b]/20' : 'rounded-xl'}`} data-id="element-259">
        {/* Badge */}
        {badge && <div className="px-5 pt-4" data-id="element-260">
            <span className="inline-flex items-center gap-1.5 bg-[#1e293b] text-white text-xs font-semibold px-3 py-1 rounded-full" data-id="element-261">
              <StarIcon className="w-3 h-3 fill-current text-yellow-400" data-id="element-262" />
              {badge}
            </span>
          </div>}

        <div className="p-5 sm:p-6 flex flex-col md:flex-row gap-5" data-id="element-263">
          {/* Left: Rank + Content */}
          <div className="flex-1 flex gap-4 min-w-0" data-id="element-264">
            {/* Rank Number */}
            <div className="flex-shrink-0 pt-1" data-id="element-265">
              <div className="w-9 h-9 rounded-full border-2 border-gray-200 flex items-center justify-center" data-id="element-266">
                <span className="text-sm font-bold text-gray-400" data-id="element-267">
                  {position}
                </span>
              </div>
            </div>

            {/* School Info */}
            <div className="flex-1 min-w-0" data-id="element-268">
              <h3 className="text-lg font-bold text-gray-900 leading-tight" data-id="element-269">
                {name}
              </h3>

              {headline && <p className="text-sm text-gray-500 mt-0.5 mb-3" data-id="element-270">{headline}</p>}

              {/* Body Content - rendered as HTML (contains <ul><li> bullet points) */}
              {bodyHtml && <div className="school-body-content text-sm text-gray-700 leading-relaxed" dangerouslySetInnerHTML={{
              __html: bodyHtml
            }} data-id="element-271" />}
            </div>
          </div>

          {/* Right: Logo + CTA */}
          <div className="flex flex-row md:flex-col items-center md:items-center justify-between md:justify-start gap-3 md:w-36 flex-shrink-0" data-id="element-272">
            {/* Logo */}
            <div className="w-36 h-24 flex items-center justify-center p-1" data-id="element-273">
              {logo ? <img src={logo} alt={`${name} logo`} className="max-w-full max-h-full object-contain" onError={e => {
              ;
              (e.target as HTMLImageElement).style.display = 'none';
              const next = (e.target as HTMLImageElement).nextElementSibling as HTMLElement;
              if (next) next.style.display = 'flex';
            }} data-id="element-274" /> : null}
              <div className={`w-full h-full items-center justify-center ${logo ? 'hidden' : 'flex'}`} data-id="element-275">
                <span className="text-sm font-bold text-navy" data-id="element-276">
                  {schoolInitials}
                </span>
              </div>
            </div>

            {/* CTA Button */}
            {clickUrl ? <a href={clickUrl} target="_blank" rel="noopener noreferrer" className="inline-flex items-center justify-center px-5 py-2.5 text-sm font-bold rounded-md text-white bg-crimson hover:bg-crimson-dark transition-colors duration-200 whitespace-nowrap shadow-sm" data-id="element-277">
                View Programs
              </a> : null}

            {/* 100% Online */}
            <div className="flex items-center gap-1 text-xs font-semibold text-gray-600" data-id="element-278">
              <StarIcon className="w-3.5 h-3.5 text-yellow-500 fill-current" data-id="element-279" />
              100% Online
            </div>
          </div>
        </div>
      </div>
    </div>;
}
export function DidYouKnowBanner() {
  return <div className="flex items-center justify-center gap-2 py-3 text-sm text-gray-600" data-id="element-280">
      <span className="text-lg" data-id="element-281">💡</span>
      <span className="font-bold text-gray-800" data-id="element-282">DID YOU KNOW?</span>
      <span data-id="element-283">Enrollments increased by 40% this year</span>
    </div>;
}